<template>
	<div
		class="create-button self-start text-muted"
		:class="{
			'flex-col w-24 h-24 p-3': type === 'small',
			'flex-col w-64 h-24 p-3': type === 'large',
			'flex-col w-56 h-48 p-3': type === 'largeBox',
			'flex flex-row w-20 h-10 p-1 justify-center': type === 'xs',
		}"
		@click="() => $refs.uploadImage.click()"
		:style="
			!backgroundImage
				? `background-image: url('${image}'); background-position: center; background-size: cover`
				: `background-color: #ffffff`
		"
	>
		<span v-if="!(image && !backgroundImage)" class="create-icon">
			<app-icon icon="plus" class="text-muted" />
		</span>
		<span v-if="type !== 'xs' && !(image && !backgroundImage)" class="text-muted">Add Image</span>
		<span v-if="type !== 'xs' && !(image && !backgroundImage)" class="text-muted text-10 pl-1">
			Image
		</span>
		<span v-if="type !== 'xs' && !(image && !backgroundImage)" class="text-muted text-8">
			PNG, JPG only
		</span>
		<input
			ref="uploadImage"
			type="file"
			accept=".png, .jpg, .gif"
			class="hidden"
			@change="onImageSelect"
			:disabled="disabled"
		/>
	</div>
	<app-modal v-if="isCroppedModalVisible" @close="closeModal" title="" @click.stop="" close-icon="save">
		<template v-slot:header>
			<span class="mr-2">Crop</span>
		</template>
		<div style="width: 950px; max-height: 480px;">
			<vue-cropper
				ref="cropper"
				:aspectRatio="aspectRatio"
				:src="image"
				style="width: 950px; max-height: 450px;"
				class="object-contain"
			/>
		</div>
	</app-modal>
</template>

<script>
	import UtilityService from '@/services/UtilityService';
	import AppModal from '@/components/app/AppModal';
	import VueCropper from 'vue-cropperjs';
	import 'cropperjs/dist/cropper.css';

	export default {
		name: 'AddIconComponent',
		components: { AppModal, VueCropper },
		props: {
			image: {},
			aspectRatio: {
				type: Number,
				default: 16 / 9,
			},
			type: {
				type: String,
				default: 'small',
			},
			customClass: {
				type: String,
				default: '',
			},
			disabled: {
				type: Boolean,
				default: false,
			},
			backgroundImage: {
				type: Boolean,
			},
		},
		emits: ['onSelect', 'onCrop'],
		data: () => ({
			croppedImage: '',
			isCroppedModalVisible: false,
		}),
		methods: {
			async onImageSelect(event) {
				const file = event.target.files[0];
				const isGif = file.name.match(/.(gif)$/i);
				if (file) {
					const stringBase64 = await UtilityService.getBase64(file, true);
					let m = encodeURIComponent(stringBase64).match(/%[89ABab]/g);
					const imageSize = stringBase64.length + (m ? m.length : 0);
					if (!isGif) {
						if (imageSize > 800 * 1024) {
							return this.$notificationService.error('Image too big');
						}
						this.showModal();
					}
					this.$emit('onSelect', stringBase64);
					event.target.value = ''; //Workaround to make reselect same file again to fire the change event
				}
			},
			showModal() {
				this.isCroppedModalVisible = true;
			},
			closeModal() {
				const canvas = this.$refs.cropper.getCroppedCanvas();
				const img = canvas.toDataURL('image/png', 1.0);
				this.$emit('onCrop', img);
				this.isCroppedModalVisible = false;
			},
		},
	};
</script>

<style scoped></style>
